import { render, staticRenderFns } from "./sendApp.vue?vue&type=template&id=125fdf70&scoped=true"
import script from "./sendApp.vue?vue&type=script&lang=ts"
export * from "./sendApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fdf70",
  null
  
)

export default component.exports